// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__3cn9j","img":"style_img__3WcSh","title":"style_title__26Byn"};